export const finance: Record<string, string> = {
  // Commission finance rates
  'fin.partner': 'Đối tác',
  'fin.product': 'Sản phẩm',
  'fin.amount': 'Số tiền',
  'fin.share': 'Cổ phần',
  // Products
  'products.emptyHint': 'Không tìm thấy sản phẩm. Chạy ETL để nhập dữ liệu.',
  'products.loadError': 'Tải thất bại',
  'products.count': 'sản phẩm',
  'products.col.code': 'Mã',
  'products.col.name': 'Tên',
  'products.col.platform': 'Nền tảng',
  'products.col.status': 'Trạng thái',
  'products.col.partner': 'Đối tác',
  'products.col.owner': 'Chủ sở hữu',
  'products.col.ratePartner': 'Tỷ lệ đối tác',
  'products.col.rateDev': 'Tỷ lệ Dev',
  'products.col.launchDate': 'Ngày ra mắt',
  'products.code': 'Mã sản phẩm',
  'products.name': 'Tên sản phẩm',
  'products.platform': 'Nền tảng',
  'products.status': 'Trạng thái',
  'products.partner': 'Đối tác',
  'products.ratePartner': 'Tỷ lệ đối tác',
  'products.dev': 'Dev',
  'products.rateDev': 'Tỷ lệ Dev',
  'products.owner': 'Chủ sở hữu (eCode)',
  'products.packageName': 'Package name',
  'products.admobId': 'AdMob ID',
  'products.store': 'Store',
  'products.storeId': 'Store ID',
  'products.mmp': 'MMP',
  'products.feeMmp': 'Phí MMP',
  'products.launchDate': 'Ngày ra mắt',
  'products.devInternal': 'Dev nội bộ',
  'products.note': 'Ghi chú',
  'products.admob': 'AdMob',
  'products.monet': 'Monetization',
  'products.created': 'Ngày tạo',
  'products.updated': 'Ngày cập nhật',
  'products.synced': 'Đồng bộ lúc',
  'products.section.identity': 'Thông tin',
  'products.section.store': 'Store / MMP',
  'products.section.rates': 'Tỷ lệ',
  'products.section.meta': 'Metadata',
  'products.uaHistory': 'Lịch sử UA',
  'products.admobHistory': 'Lịch sử AdMob',
  'admobHistory.startDate': 'Ngày bắt đầu',
  'admobHistory.endDate': 'Ngày kết thúc',
  'admobHistory.active': 'Đang dùng',
  'products.edit': 'Sửa',
  'products.editTitle': 'Sửa sản phẩm',
  'products.createTitle': 'Thêm sản phẩm',
  'products.createSubmit': 'Tạo sản phẩm',
  'products.declareHint': 'Sản phẩm mới sẽ ở trạng thái PENDING chờ admin duyệt; bạn được ghi nhận là dev của sản phẩm.',
  'products.declareSuccess': 'Đã khai báo sản phẩm {code} (PENDING — chờ admin duyệt).',
  'products.codeTaken': 'Mã dự án đã tồn tại.',
  'products.codeFree': 'Mã dự án hợp lệ.',
  'products.deactivate': 'Ngừng hoạt động',
  'products.activate': 'Kích hoạt',
  'products.activateConfirm': 'Kích hoạt lại sản phẩm {code} (chuyển ACTIVE)?',
  'products.deactivateConfirm': 'Chuyển sản phẩm {code} sang INACTIVE? (Sản phẩm không bị xoá, chỉ ngừng hoạt động.)',
  'products.changeAdmobTitle': 'Đổi AdMob ID',
  'products.currentAdmobId': 'AdMob ID hiện tại',
  'products.newAdmobId': 'AdMob ID mới',
  'products.changeDate': 'Ngày hiệu lực',
  'products.uaOwner': 'Chủ UA',
  'products.uaChangeReason': 'Lý do đổi UA',
  'products.uaChangeReasonPlaceholder': 'Lý do thay đổi chủ UA (không bắt buộc)',
  // Finance (revenue/cost + IAP)
  'finance.col.totalCost': 'Tổng chi phí',
  'finance.col.profit': 'Lợi nhuận',
  'finance.col.roas': 'ROAS',
  // RevCost tab
  'revcost.tab': 'Doanh thu & Chi phí',
  'revcost.revenue': 'Doanh thu',
  'revcost.totalCost': 'Tổng chi phí',
  'revcost.amplitude': 'Biên độ',
  'revcost.sortBy': 'Sắp xếp:',
  'revcost.sortRev': 'Doanh thu',
  'revcost.sortProfit': 'Lợi nhuận',
  'revcost.sortCost': 'Chi phí',
  'revcost.sortAbc': 'ABC',
  // ARPU tab
  'arpu.tab': 'ARPU',
  'arpu.byDate': 'Theo ngày',
  'arpu.byCountry': 'Theo quốc gia',
  'arpu.filterCountry': 'Lọc quốc gia',
  'arpu.col.date': 'Ngày',
  'arpu.col.country': 'Quốc gia',
  'arpu.col.earnings': 'Doanh thu ước tính',
  'arpu.col.iap': 'IAP',
  'arpu.col.ecpm': 'eCPM',
  'arpu.col.au': 'Người dùng hoạt động',
  'arpu.col.adsArpu': 'Ads ARPU',
  'arpu.col.impr': 'Lượt hiển thị',
  'arpu.col.matchRate': 'Tỷ lệ khớp',
  // Dev Adjustment tab
  'devadj.tab': 'Điều chỉnh',
  'devadj.col.multiplier': 'Hệ số',
  'devadj.month': 'Tháng',
  'devadj.addApp': 'Thêm app',
  'devadj.wholeMonth': 'Cả tháng',
  'devadj.revenue': 'Doanh thu',
  'devadj.baseCost': 'Chi phí gốc',
  'devadj.profitBefore': 'Lợi nhuận trước',
  'devadj.profitAfter': 'Lợi nhuận sau',
  'devadj.saved': 'Đang lưu…',
  'devadj.remove': 'Xoá',
  'devadj.totals': 'Tổng',
  'devadj.noData': 'Không có dữ liệu tháng này',
  'devadj.logs': 'Lịch sử thay đổi',
  'devadj.log.time': 'Thời gian',
  'devadj.log.actor': 'Người sửa',
  'devadj.log.target': 'App / Nhóm',
  'devadj.log.period': 'Kỳ',
  'devadj.log.change': 'Thay đổi',
  'devadj.log.group': 'Nhóm',
  'devadj.log.removed': 'đã xoá',
  'products.iapEstimate': 'Ước tính IAP',
  'iapEst.title': 'Tính ước tính IAP vào report',
  'iapEst.stateOn': 'ĐANG BẬT',
  'iapEst.stateOff': 'ĐANG TẮT',
  'iapEst.onNote': 'Report có gộp ước tính IAP cho những tháng Google chưa chốt. Số ước tính được đánh dấu hoa thị. Sai số khoảng 1% trên tổng tháng.',
  'iapEst.offNote': 'Report chỉ hiện IAP đã chốt. Tháng Google chưa chốt sẽ đọc là không có IAP, và profit với ROAS tính theo đó.',
  'iapEst.turnOff': 'Tắt',
  'iapEst.turnOn': 'Bật',
  'iapEst.nowOn': 'Ước tính IAP giờ được tính vào report.',
  'iapEst.nowOff': 'Report giờ chỉ hiện IAP đã chốt.',
  'iapEst.lastChanged': 'Đổi lần cuối bởi',
  'iapEst.commissionNote': 'Hoa hồng không đổi ở cả hai trạng thái — nó trả từ số đã chốt và không bao giờ đọc ước tính.',
};
